/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Breadcrumbs } from "~/components";
import { useCustomer } from "~/context/User/Customer";

function CustomerBreadcrumbs() {
  const { customer } = useCustomer();

  const customerBread = [
    { label: "Customers", uri: "/customers" },
    { label: customer.name, uri: "/" },
  ];

  return (
    <Breadcrumbs
      title={customer.name || ""}
      customBreadcrumbs={customerBread}
    />
  );
}

export { CustomerBreadcrumbs };
